// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Images/CA_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}


.main-grid{
    display: grid;
    justify-content: center;
    width: 100%;
}

.grid-container {
    margin-top: 65px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    /* column-gap: 5px; */
    row-gap: 15px;
    /* padding: 20px; */
    margin-right: 60px;

  }
  @media only screen and (min-width: 1400px){
    .grid-container {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    column-gap: 5px;
    }
  }



  .grid-item {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% 100%;
    /* border: 1px solid rgba(0, 0, 0, 0.8); */
    /* padding: 20px;  */
    font-size: 30px;
    text-align: center;
    height: 328px;
    width: 280px;
    display: flex;
    flex-direction: column;

    
  }

  .grid-container :nth-child(4n){
    margin-top: 10px;
  }
  /* .grid-container :nth-child(8){
    margin-top: 10px;
  } */

  .search-bar{

    grid-column: 1/3;
    display: flex;
    align-self: center;
    flex-direction: row;
    padding: 10px;
    background: #000000;
    bottom: 20px;
    justify-content: space-evenly;
    font-family: PP-nuebit;
  }



  .search-white{
    
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: row;
    background: #ffffff;
    color: #000000;
    align-items: center;
    justify-content: space-evenly;
  }

  .input-field{
    width: 70%;
    height: 40px;
    border: none;
  }

  .input-field :focus-visible{
    border: none;
  }


  .search-grid{

    position: -webkit-sticky;
    position: fixed;
    width:45%;
    bottom: 10px;
    left: 27%;
    display: grid;
    background-color: #000000;
    color: white;
    grid-template-columns: 1fr 1fr 1fr;
    font-family: PP-Nuebit;
font-size: 20px;
font-weight: 700;
line-height: 14px;
display: none;
letter-spacing: 0em;
  }

  .search-grid-item{
    margin-left: 25px;
    display: none;
    text-align: center;
    padding: 15px;
    cursor: pointer;
    text-align: left;

  }

  .search-grid-item.active{
    display: block;
  }

  .filter{
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    font-size: 20px;
  }

  .filter p{
    cursor: pointer;
  }

.popup{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: fixed;
  align-items: center;
  top: 0vh;
  left: 0vw;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  background: rgba(0, 0, 0, 0.65);
  
}

.close-btn{
  
    background: white;
    padding: 19px;
    font-family: 'PP-Nuebit';
    font-size: 30px;
    margin: 0;
  cursor: pointer;
}

.pop-close{
  padding: 10px;
  cursor: pointer;
}

@media only screen and (max-width: 1200px){
  .grid-container{
    grid-template-columns: 1fr 1fr 1fr;
  }
  }

@media only screen and (max-width: 600px){
  

    .grid-container{
      margin-top: 10vh;
      grid-template-columns: 54% 40%;
      margin-right: 0;
      width: 90vw;
    }

    .search-grid{
      display: none;
    }

    


}
  
`, "",{"version":3,"sources":["webpack://./src/components/Pages/CaPage/CaPage.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAoD;AACxD;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sCAAsC;IACtC,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;EAEpB;EACA;IACE;IACA,0CAA0C;IAC1C,eAAe;IACf;EACF;;;;EAIA;IACE,yDAAyD;IACzD,0BAA0B;IAC1B,0CAA0C;IAC1C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;;;EAGxB;;EAEA;IACE,gBAAgB;EAClB;EACA;;KAEG;;EAEH;;IAEE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;EACxB;;;;EAIA;;IAEE,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;;EAGA;;IAEE,wBAAwB;IACxB,eAAe;IACf,SAAS;IACT,YAAY;IACZ,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;IAClC,sBAAsB;AAC1B,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,aAAa;AACb,mBAAmB;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;;EAElB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+BAA+B;;AAEjC;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,wBAAwB;IACxB,eAAe;IACf,SAAS;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;;AAEF;;;IAGI;MACE,gBAAgB;MAChB,8BAA8B;MAC9B,eAAe;MACf,WAAW;IACb;;IAEA;MACE,aAAa;IACf;;;;;AAKJ","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n\n\n.main-grid{\n    display: grid;\n    justify-content: center;\n    width: 100%;\n}\n\n.grid-container {\n    margin-top: 65px;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    /* column-gap: 5px; */\n    row-gap: 15px;\n    /* padding: 20px; */\n    margin-right: 60px;\n\n  }\n  @media only screen and (min-width: 1400px){\n    .grid-container {\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    column-gap: 5px;\n    }\n  }\n\n\n\n  .grid-item {\n    background-image: url(\"../../../assets/Images/CA_bg.png\");\n    background-size: 100% 100%;\n    /* border: 1px solid rgba(0, 0, 0, 0.8); */\n    /* padding: 20px;  */\n    font-size: 30px;\n    text-align: center;\n    height: 328px;\n    width: 280px;\n    display: flex;\n    flex-direction: column;\n\n    \n  }\n\n  .grid-container :nth-child(4n){\n    margin-top: 10px;\n  }\n  /* .grid-container :nth-child(8){\n    margin-top: 10px;\n  } */\n\n  .search-bar{\n\n    grid-column: 1/3;\n    display: flex;\n    align-self: center;\n    flex-direction: row;\n    padding: 10px;\n    background: #000000;\n    bottom: 20px;\n    justify-content: space-evenly;\n    font-family: PP-nuebit;\n  }\n\n\n\n  .search-white{\n    \n    width: 100%;\n    height: 80%;\n    display: flex;\n    flex-direction: row;\n    background: #ffffff;\n    color: #000000;\n    align-items: center;\n    justify-content: space-evenly;\n  }\n\n  .input-field{\n    width: 70%;\n    height: 40px;\n    border: none;\n  }\n\n  .input-field :focus-visible{\n    border: none;\n  }\n\n\n  .search-grid{\n\n    position: -webkit-sticky;\n    position: fixed;\n    width:45%;\n    bottom: 10px;\n    left: 27%;\n    display: grid;\n    background-color: #000000;\n    color: white;\n    grid-template-columns: 1fr 1fr 1fr;\n    font-family: PP-Nuebit;\nfont-size: 20px;\nfont-weight: 700;\nline-height: 14px;\ndisplay: none;\nletter-spacing: 0em;\n  }\n\n  .search-grid-item{\n    margin-left: 25px;\n    display: none;\n    text-align: center;\n    padding: 15px;\n    cursor: pointer;\n    text-align: left;\n\n  }\n\n  .search-grid-item.active{\n    display: block;\n  }\n\n  .filter{\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    font-size: 20px;\n  }\n\n  .filter p{\n    cursor: pointer;\n  }\n\n.popup{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  position: fixed;\n  align-items: center;\n  top: 0vh;\n  left: 0vw;\n  height: 100vh;\n  width: 100vw;\n  z-index: 100;\n  background: rgba(0, 0, 0, 0.65);\n  \n}\n\n.close-btn{\n  \n    background: white;\n    padding: 19px;\n    font-family: 'PP-Nuebit';\n    font-size: 30px;\n    margin: 0;\n  cursor: pointer;\n}\n\n.pop-close{\n  padding: 10px;\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 1200px){\n  .grid-container{\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n  }\n\n@media only screen and (max-width: 600px){\n  \n\n    .grid-container{\n      margin-top: 10vh;\n      grid-template-columns: 54% 40%;\n      margin-right: 0;\n      width: 90vw;\n    }\n\n    .search-grid{\n      display: none;\n    }\n\n    \n\n\n}\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
